import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "surface-section p-4" }
const _hoisted_2 = { class: "grid font-medium text-900 mb-3 flex justify-content-between card-container" }
const _hoisted_3 = { class: "text-3xl" }
const _hoisted_4 = { class: "flex flex-row-reverse flex-wrap col-8" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex mr-2" }
const _hoisted_7 = { class: "text-500 mb-5" }
const _hoisted_8 = { class: "surface-card p-0 m-0 list-none flex overflow-x-auto select-none" }
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home mr-2" }, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Chi tiết", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users mr-2" }, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Hình ảnh", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($setup.plant.name), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              class: "p-button-danger",
              icon: "pi pi-delete",
              label: "Xoá cây thuốc",
              loading: $setup.isLoading,
              onClick: $setup.deletePlant
            }, null, 8 /* PROPS */, ["loading"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!$setup.plant.publish)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-success",
                  icon: "pi pi-eye",
                  label: "Hiển thị cây thuốc",
                  loading: $setup.isLoading,
                  onClick: $setup.activePlant
                }, null, 8 /* PROPS */, ["loading"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "p-button-secondary",
                  icon: "pi pi-eye-slash",
                  label: "Ẩn cây thuốc",
                  loading: $setup.isLoading,
                  onClick: $setup.activePlant
                }, null, 8 /* PROPS */, ["loading"]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString($setup.plant.description), 1 /* TEXT */),
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _withDirectives((_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple", {'border-blue-500 text-blue-500 hover:border-blue-500': $setup.tabIndex === 0, 'text-700 border-transparent': $setup.tabIndex !== 0}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.tabIndex = 0))
          }, _hoisted_12, 2 /* CLASS */)), [
            [_directive_ripple]
          ])
        ]),
        _createElementVNode("li", _hoisted_13, [
          _withDirectives((_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 p-ripple", {'border-blue-500 text-blue-500 hover:border-blue-500': $setup.tabIndex === 1, 'text-700 border-transparent': $setup.tabIndex !== 1}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.tabIndex = 1))
          }, _hoisted_16, 2 /* CLASS */)), [
            [_directive_ripple]
          ])
        ])
      ])
    ]),
    ($setup.tabIndex === 0)
      ? (_openBlock(), _createBlock($setup["PlantForm"], {
          key: 0,
          plant: {...$setup.plant},
          id: $props.id
        }, null, 8 /* PROPS */, ["plant", "id"]))
      : _createCommentVNode("v-if", true),
    ($setup.tabIndex === 1)
      ? (_openBlock(), _createBlock($setup["ImageViewList"], {
          key: 1,
          plant: {...$setup.plant}
        }, null, 8 /* PROPS */, ["plant"]))
      : _createCommentVNode("v-if", true)
  ]))
}